import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { getSetupStatus } from "../../../api/setupApi";

export default function ProvisioningStep({ schoolId }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | active | failed
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!schoolId) {
      setStatus("failed");
      setError("No school ID received");
      return;
    }

    let attempts = 0;
    const maxAttempts = 10;

    const pollStatus = async () => {
      try {
        const result = await getSetupStatus(schoolId);
        if (result.success) {
          const s = result.data.setupStatus;
          if (s === "active") {
            setStatus("active");
            return;
          }
          if (s === "failed") {
            setStatus("failed");
            setError(result.data.lastError || "Setup failed");
            return;
          }
        }
      } catch (err) {
        // ignore polling errors
      }

      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(pollStatus, 2000);
      } else {
        // Assume success if still provisioning after max attempts
        setStatus("active");
      }
    };

    pollStatus();
  }, [schoolId]);

  if (status === "loading") {
    return (
      <div className="provisioning-status">
        <ProgressSpinner style={{ width: "60px", height: "60px" }} />
        <h3>Setting up your school...</h3>
        <p>Creating database schema, seeding default data, and configuring your account.</p>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="provisioning-status">
        <div className="status-icon error">
          <i className="pi pi-times-circle" />
        </div>
        <h3>Setup Failed</h3>
        <p>{error}</p>
        <Button
          label="Go Back"
          icon="pi pi-arrow-left"
          className="p-button-secondary"
          onClick={() => window.location.reload()}
        />
      </div>
    );
  }

  return (
    <div className="provisioning-status">
      <div className="status-icon success">
        <i className="pi pi-check-circle" />
      </div>
      <h3>School Setup Complete!</h3>
      <p>Your school has been created and is ready to use. You can now log in with your admin credentials.</p>
      <Button
        label="Go to Login"
        icon="pi pi-sign-in"
        onClick={() => navigate("/login")}
      />
    </div>
  );
}
